"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: paging/paging.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fpaging%2Fpaging.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortOrderToJSON = exports.sortOrderFromJSON = exports.PagingResponse = exports.PagingRequest = exports.SortOrder = void 0;
const protobufPackage = 'com.step.paging.proto';
var SortOrder;
(function (SortOrder) {
    SortOrder["INVALID_SORT_ORDER"] = "INVALID_SORT_ORDER";
    SortOrder["DESC"] = "DESC";
    SortOrder["ASC"] = "ASC";
    SortOrder["UNRECOGNIZED"] = "UNRECOGNIZED";
})(SortOrder || (exports.SortOrder = SortOrder = {}));
function createBasePagingRequest() {
    return {
        limit: 0,
        nextOffset: undefined,
        prevOffset: undefined,
        sortOrder: SortOrder.INVALID_SORT_ORDER,
    };
}
exports.PagingRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.limit)) {
            message.limit = globalThis.Number(object.limit);
        }
        if (isSet(object.nextOffset)) {
            message.nextOffset = globalThis.String(object.nextOffset);
        }
        if (isSet(object.prevOffset)) {
            message.prevOffset = globalThis.String(object.prevOffset);
        }
        if (isSet(object.sortOrder)) {
            message.sortOrder = sortOrderFromJSON(object.sortOrder);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.limit !== undefined && message.limit !== 0) {
            obj.limit = Math.round(message.limit);
        }
        if (message.nextOffset !== undefined) {
            obj.nextOffset = message.nextOffset;
        }
        if (message.prevOffset !== undefined) {
            obj.prevOffset = message.prevOffset;
        }
        if (message.sortOrder !== undefined && message.sortOrder !== SortOrder.INVALID_SORT_ORDER) {
            obj.sortOrder = sortOrderToJSON(message.sortOrder);
        }
        return obj;
    },
    create(base) {
        return exports.PagingRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePagingRequest();
        message.limit = object.limit ?? 0;
        message.nextOffset = object.nextOffset ?? undefined;
        message.prevOffset = object.prevOffset ?? undefined;
        message.sortOrder = object.sortOrder ?? SortOrder.INVALID_SORT_ORDER;
        return message;
    },
};
function createBasePagingResponse() {
    return { nextOffset: '', prevOffset: '', hasMore: undefined };
}
exports.PagingResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.nextOffset)) {
            message.nextOffset = globalThis.String(object.nextOffset);
        }
        if (isSet(object.prevOffset)) {
            message.prevOffset = globalThis.String(object.prevOffset);
        }
        if (isSet(object.hasMore)) {
            message.hasMore = globalThis.Boolean(object.hasMore);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.nextOffset !== undefined && message.nextOffset !== '') {
            obj.nextOffset = message.nextOffset;
        }
        if (message.prevOffset !== undefined && message.prevOffset !== '') {
            obj.prevOffset = message.prevOffset;
        }
        if (message.hasMore !== undefined) {
            obj.hasMore = message.hasMore;
        }
        return obj;
    },
    create(base) {
        return exports.PagingResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePagingResponse();
        message.nextOffset = object.nextOffset ?? '';
        message.prevOffset = object.prevOffset ?? '';
        message.hasMore = object.hasMore ?? undefined;
        return message;
    },
};
function sortOrderFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SORT_ORDER':
            return SortOrder.INVALID_SORT_ORDER;
        case 1:
        case 'DESC':
            return SortOrder.DESC;
        case 2:
        case 'ASC':
            return SortOrder.ASC;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return SortOrder.UNRECOGNIZED;
    }
}
exports.sortOrderFromJSON = sortOrderFromJSON;
function sortOrderToJSON(object) {
    switch (object) {
        case SortOrder.INVALID_SORT_ORDER:
            return 'INVALID_SORT_ORDER';
        case SortOrder.DESC:
            return 'DESC';
        case SortOrder.ASC:
            return 'ASC';
        case SortOrder.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.sortOrderToJSON = sortOrderToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=paging.js.map